export default __webpack_public_path__ + "static/media/TitleVideo.077ff093.mp4";